<abc-popup
  #task_popup
  [height]="'auto'"
  [maxHeight]="'95%'"
  [minHeight]="'400px'"
  [width]="'95%'"
  [maxWidth]="'800px'"
  [minWidth]="'300px'"
  [showCloseButton]="true"
  [showTitle]="true"
  (onHidden)="resetValues()"
>
  <div class="dx-card popup-card-paddings card-radius" style="overflow-y: scroll">
    <form action="post" (submit)="persistMeasureSubTask($event)">
      <abc-form #task_form id="form" [colCount]="1">
        <dxi-item [isRequired]="true">
          <dx-text-box
            [stylingMode]="'outlined'"
            [width]="'100%'"
            [labelMode]="'floating'"
            [(value)]="measureTask.Label"
            [label]="resources('Ubt-MeasureTask-Label')"
            [disabled]="!canManageTasks"
          >
          </dx-text-box>
          <dxi-validation-rule type="required" [message]="resources('Ubt-MeasureTask-Label') + ' is required'">
          </dxi-validation-rule>
        </dxi-item>

        <dxi-item itemType="group" [colCount]="3" [cssClass]="'form-fields-row'" [attr.data-col-count]="'3'">
          <dxi-item [isRequired]="true">
            <dx-date-box
              class="date-box-style"
              [stylingMode]="'outlined'"
              [width]="'100%'"
              [(value)]="measureTask.StartDate"
              [labelMode]="'floating'"
              [label]="resources('Ubt-Measure-List-StartDate')"
              [disabled]="!canManageTasks"
              [max]="measureTask.EndDate"
            >
            </dx-date-box>
            <dxi-validation-rule type="required" [message]="resources('Ubt-Measure-List-StartDate') + ' is required'">
            </dxi-validation-rule>
          </dxi-item>

          <dxi-item [isRequired]="true">
            <dx-date-box
              class="date-box-style"
              [stylingMode]="'outlined'"
              [(value)]="measureTask.EndDate"
              [max]="task.EndDate"
              [width]="'100%'"
              [labelMode]="'floating'"
              [label]="resources('Ubt-Measure-List-EndDate')"
              [disabled]="!canManageTasks"
              [min]="measureTask.StartDate"
            >
            </dx-date-box>
            <dxi-validation-rule type="required" [message]="resources('Ubt-Measure-List-EndDate') + ' is required'">
            </dxi-validation-rule>
          </dxi-item>

          <dxi-item [isRequired]="true">
            <dx-date-box
              class="date-box-style"
              [stylingMode]="'outlined'"
              [(value)]="measureTask.EndDate"
              [width]="'100%'"
              [labelMode]="'floating'"
              [label]="resources('Ubt-MeasureTask-Target-date')"
              [disabled]="!canManageTasks"
            >
            </dx-date-box>
            <dxi-validation-rule type="required" [message]="resources('Ubt-MeasureTask-Target-date') + ' is required'">
            </dxi-validation-rule>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" [colCount]="2" [cssClass]="'form-fields-row'" [attr.data-col-count]="'2'">
          <dxi-item [isRequired]="true">
            <dx-select-box
              fxFill
              class="drop-down-style"
              valueExpr="Id"
              [displayExpr]="dataService.getResponsibleFullName"
              [(value)]="measureTask.Responsible"
              [dataSource]="dataService.cachedResponsiblesResponse"
              [label]="resources('Ubt-CreateMeasure-Responsible')"
              [labelMode]="'floating'"
              [acceptCustomValue]="true"
              [disabled]="!canManageTasks"
              (keydown)="$event.preventDefault()"
            >
            </dx-select-box>
            <dxi-validation-rule
              type="required"
              [message]="resources('Ubt-CreateMeasure-Responsible') + ' is required'"
            >
            </dxi-validation-rule>
          </dxi-item>
          <dxi-item>
            <dx-select-box
              class="drop-down-style"
              [width]="'100%'"
              [(value)]="measureTask.Status"
              [dataSource]="measureTaskStatus"
              displayExpr="name"
              valueExpr="value"
              [stylingMode]="'outlined'"
              [labelMode]="'floating'"
              [disabled]="!canManageTasks"
              [label]="resources('Ubt-Measure-Detail-Status-Label')"
            >
            </dx-select-box>
          </dxi-item>
        </dxi-item>

        <dxi-item itemType="group" [colCount]="2" [cssClass]="'form-fields-row'" [attr.data-col-count]="'2'">
          <dxi-item>
            <dx-number-box
              #efficiencyField
              [stylingMode]="'outlined'"
              [width]="'100%'"
              [min]="0"
              [(value)]="measureTask.DegreeOfImplementation"
              [max]="100"
              [format]="dataService.customizePercentageText"
              [labelMode]="'floating'"
              [disabled]="!canManageTasks"
              [label]="resources('Ubt-MeasureTask-DegreeOfImplementation')"
            >
            </dx-number-box>
          </dxi-item>
          <dxi-item>
            <dx-number-box
              [stylingMode]="'outlined'"
              [width]="'100%'"
              [label]="resources('Ubt-CreateMeasureTask-Total-Time')"
              [labelMode]="'floating'"
              format="#,##0 h"
              [(value)]="measureTask.TotalTimeRequired"
              [disabled]="!canManageTasks"
            >
            </dx-number-box>
          </dxi-item>
        </dxi-item>

        <dxi-item>
          <div *dxTemplate fxLayout="column">
            <div fxLayout="row" fxFlexFill>
              <div fxLayout="column" fxFlexFill>
                <abc-button
                  class="submit-button"
                  stylingMode="text"
                  text="Zeitstempel hinzufügen"
                  type="default"
                  [hoverStateEnabled]="false"
                  [disabled]="!canManageTasks"
                  (onClick)="addUserNameAndTimeToNotes()"
                >
                </abc-button>
                <abc-text-area
                  style="width: 100%"
                  class="comment-textarea"
                  [placeholder]="'Notizen'"
                  [(value)]="measureTask.Comment"
                  [disabled]="!canManageTasks"
                ></abc-text-area>
              </div>
            </div>
          </div>
        </dxi-item>

        <dxi-item>
          <div *dxTemplate fxLayout="column">
            <div fxLayout="row">
              <ubt-geods-collaborators
                #collaboratorGrid
                [dataSource]="measureTask.Collaborators"
                [assignedResources]="currentMeasure.Resources"
                [currentMeasureTask]="measureTask"
                [canManageTasks]="canManageTasks"
                (onCalculateOverallTime)="onCalculateOverallTime($event)"
              >
              </ubt-geods-collaborators>
            </div>
          </div>
        </dxi-item>

        <dxi-item itemType="group" [cssClass]="'form-buttons-container'">
          <dxi-item itemType="button" [cssClass]="'submit-button'" [buttonOptions]="submitButtonOptions"> </dxi-item>
          <dxi-item itemType="button" [cssClass]="'cancel-button'" [buttonOptions]="cancelButtonOptions"> </dxi-item>
        </dxi-item>
      </abc-form>
    </form>
  </div>
</abc-popup>
